// Implements: F-UIX-019
/**
 * The days "Consumo del mes" covers on Plataforma > Organizaciones: from the first day of the
 * reader's current month to today, as `YYYY-MM-DD` calendar days in the reader's zone. The clock is
 * the caller's (`now`), so the rule is tested without the real one.
 */

export interface MonthRange {
  readonly from: string;
  readonly to: string;
}

function day(year: number, monthIndex: number, date: number): string {
  return `${String(year)}-${String(monthIndex + 1).padStart(2, "0")}-${String(date).padStart(2, "0")}`;
}

export function monthToDate(now: Date): MonthRange {
  return {
    from: day(now.getFullYear(), now.getMonth(), 1),
    to: day(now.getFullYear(), now.getMonth(), now.getDate()),
  };
}
